"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleSDK = void 0;
var dropsite_lib_1 = require("@manifoldxyz/dropsite-lib");
var frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
var CollectibleServerAPI_1 = require("./api/CollectibleServerAPI");
var OAuthServerAPI_1 = require("./api/OAuthServerAPI");
var StudioAppServerAPI_1 = require("./api/StudioAppServerAPI");
var CollectibleContract_1 = require("./lib/CollectibleContract");
var CollectibleEligibilityChecker_1 = require("./lib/CollectibleEligibilityChecker");
var CollectibleMinter_1 = require("./lib/CollectibleMinter");
var CollectibleStore_1 = require("./lib/CollectibleStore");
var MANIFOLD_RECAPTCHA_SITE_KEY = '6LdulQUdAAAAAHiiBzk_d0kKIEXarmcOK8tgvHKN';
var CollectibleSDK = /** @class */ (function () {
    function CollectibleSDK(params, 
    // Data providers are injected here so that we can mock interface boundaries in tests
    dataProviders) {
        if (dataProviders === void 0) { dataProviders = {
            collectibleServerAPI: new CollectibleServerAPI_1.CollectibleServerAPI(params.collectibleServerURL),
            oauthServerAPI: new OAuthServerAPI_1.OAuthServerAPI(),
            studioAppServerAPI: new StudioAppServerAPI_1.StudioAppServerAPI(),
        }; }
        var _this = this;
        this.dataProviders = dataProviders;
        this.subscribe = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = _this.store).subscribe.apply(_a, args);
        };
        this.unsubscribe = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = _this.store).unsubscribe.apply(_a, args);
        };
        this.syncStoreStateWithContractState = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = this.store).setState;
                        return [4 /*yield*/, this.contract.state()];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/];
                }
            });
        }); };
        this.onConnectionChange = function () { return __awaiter(_this, void 0, void 0, function () {
            var walletAddress, isConnected, ethereumProvider, _a, _b, _c;
            var _d;
            var _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        walletAddress = (_e = window.ManifoldEthereumProvider) === null || _e === void 0 ? void 0 : _e.selectedAddress();
                        isConnected = Boolean(walletAddress);
                        ethereumProvider = (_f = window.ManifoldEthereumProvider) === null || _f === void 0 ? void 0 : _f.provider();
                        _b = (_a = this.store).setState;
                        _d = {
                            walletAddress: walletAddress,
                            isWrongChain: !Boolean((_g = window.ManifoldEthereumProvider) === null || _g === void 0 ? void 0 : _g.chainIsCorrect())
                        };
                        if (!(isConnected && ethereumProvider)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (ethereumProvider === null || ethereumProvider === void 0 ? void 0 : ethereumProvider.getBalance(walletAddress))];
                    case 1:
                        _c = _h.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _c = '0';
                        _h.label = 3;
                    case 3:
                        _b.apply(_a, [(_d.walletBalance = _c,
                                _d)]);
                        this.contract.resetContractInstance();
                        return [4 /*yield*/, this.syncStoreStateWithContractState()];
                    case 4:
                        _h.sent();
                        this.contract.onContractStateChange(this.syncStoreStateWithContractState);
                        this.eligibilityChecker.checkSaleEligibility();
                        return [2 /*return*/];
                }
            });
        }); };
        this.fetchOAuth = function () { return __awaiter(_this, void 0, void 0, function () {
            var accessToken, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, ((_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.getOAuth({
                                grantType: frontend_provider_types_1.OAuthGrantType.SIGNATURE,
                                appName: this.store.state.appName,
                                clientId: this.store.state.clientId,
                                message: this.store.state.authMessage,
                                delayAuth: this.store.state.shouldDelayAuth,
                            }))];
                    case 1:
                        accessToken = _c.sent();
                        this.dataProviders.collectibleServerAPI.setAccessToken(accessToken);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _c.sent();
                        // Error with getting oauth so disconnect, which will force user to reconnect
                        console.log('Error getting OAuth', error_1);
                        return [4 /*yield*/, ((_b = window.ManifoldEthereumProvider) === null || _b === void 0 ? void 0 : _b.disconnect())];
                    case 3:
                        _c.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.installRecaptcha = function () {
            if (typeof window !== 'undefined' && !window.recaptchaReady) {
                var elLoadCallback = document.createElement('script');
                elLoadCallback.innerHTML =
                    'var onloadCallback = function() { window.recaptchaReady = true; };';
                document.head.appendChild(elLoadCallback);
                var elRecaptchaScript = document.createElement('script');
                elRecaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit');
                elRecaptchaScript.setAttribute('async', 'true');
                elRecaptchaScript.setAttribute('defer', 'true');
                document.head.appendChild(elRecaptchaScript);
            }
        };
        this.store = new CollectibleStore_1.CollectibleStore(params);
        this.contract = CollectibleContract_1.CollectibleContract.create(this.store, dataProviders);
        this.minter = new CollectibleMinter_1.CollectibleMinter(this.contract, this.store, this.dataProviders);
        this.eligibilityChecker = new CollectibleEligibilityChecker_1.CollectibleEligibilityChecker(this.store, dataProviders, this.contract, this.fetchOAuth);
        this.store.subscribe('salePhase', function () { return _this.eligibilityChecker.checkSaleEligibility(); });
        this.contract.onContractStateChange(this.syncStoreStateWithContractState);
        (0, dropsite_lib_1.setProviderEventsHandler)(this.onConnectionChange);
        this.syncStoreStateWithContractState();
        this.syncTimeOffset();
        this.installRecaptcha();
        this.onConnectionChange();
    }
    Object.defineProperty(CollectibleSDK.prototype, "state", {
        get: function () {
            return this.store.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectibleSDK.prototype, "contractInstance", {
        get: function () {
            return this.contract.contractInstance;
        },
        enumerable: false,
        configurable: true
    });
    CollectibleSDK.prototype.purchase = function (params, options) {
        if (options === void 0) { options = {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onStateChange: function () { },
        }; }
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.setState({
                            isPurchasing: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.syncStoreStateWithContractState()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.minter.purchase(params, options)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_1 = _a.sent();
                        this.resetRecaptchaToken();
                        options.onStateChange({
                            status: 'Error',
                            data: {
                                error: e_1,
                                errorMessage: e_1.message,
                            },
                        });
                        throw e_1;
                    case 5:
                        this.store.setState({
                            isPurchasing: false,
                        });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CollectibleSDK.prototype.claim = function (params, options) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.setState({
                            isClaiming: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.syncStoreStateWithContractState()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.minter.claim(params, options)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_2 = _a.sent();
                        this.resetRecaptchaToken();
                        options.onStateChange({
                            status: 'Error',
                            data: {
                                error: e_2,
                                errorMessage: e_2.message,
                            },
                        });
                        throw e_2;
                    case 5:
                        this.store.setState({
                            isClaiming: false,
                        });
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CollectibleSDK.prototype.renderRecaptcha = function (el, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (typeof window !== 'undefined' && window.recaptchaReady) {
                    window.grecaptcha.render(el, {
                        sitekey: MANIFOLD_RECAPTCHA_SITE_KEY,
                        callback: callback,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    CollectibleSDK.prototype.resetRecaptchaToken = function () {
        try {
            window.grecaptcha.reset();
        }
        catch (e) { }
    };
    CollectibleSDK.prototype.syncTimeOffset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeOffset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dataProviders.oauthServerAPI.fetchTimeOffset()];
                    case 1:
                        timeOffset = _a.sent();
                        this.store.setState({
                            offset: timeOffset,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return CollectibleSDK;
}());
exports.CollectibleSDK = CollectibleSDK;
